import React, { useState }  from 'react';
import ReactSlider from 'react-slider';
const Palkkalaskuri: React.FunctionComponent = () => {
    
  const [price, setPrice] = useState(95);
  const [hours, setHours] = useState(158);
  let salary : number =  100;

  salary = (price * hours * 0.7) / 1.5;
  salary = Math.round(salary);

  if(salary <= 3000 ){
      salary = 3000;
  }
  
   return (<div>
    <div className="slidercontainer">
    <ReactSlider className="rslider"
          thumbClassName="rslider-thumb"
          trackClassName="rslider-track"
          min={40} max={150} step={1}value={price} onChange={(value) => setPrice(value)}/>
    </div>
    <br />
    {price}€ <br/>< br />
    Billable hours: <br  />
    <div className="slidercontainer">
    <ReactSlider className="rslider"
          thumbClassName="rslider-thumb"
          trackClassName="rslider-track"
          min={80} max={200} step={1} value={hours} onChange={(value) => setHours(value)}/>
    </div>
    <br />
    {hours} hours <br /><br />
    <b>Salary: {salary}</b>
   </div>);    
}

export default Palkkalaskuri;